export default {
    lang: {
        LoadMore: 'Load more',
        AllLoaded: 'All loaded',
        ChangeLanguage: 'Change Language',
        ChangePassword: 'Change PassWord',
        copy: 'Copy',
        copySuccess: 'Replicating Success',
        copyError: 'Copy Failed',
        CopyEmptyTips: 'The copied content cannot be empty',
        empty: 'Empty here',
        tips: 'Tips',
        cancel: 'Cancel',
        confirm: 'Confirm',
        more: 'More',
        isCloseGame: 'Do you want to close the game?',
        back: 'Back',
        Claim: 'Claim',
        Loading: 'Loading',
        Play: 'Play',
        Download: 'Download',
        NoData: 'Oops! No data yet!',
        NoMore: 'No More',
        CurrentlyPage: 'Currently on this page',
        keywordPlaceholder: 'Please enter the name of the game you want to search for!',
        SearchGameByName: 'Search the name of the game'
    },
    tabbar: {
        sport: 'sport',
        menu: 'menu',
        Lobby: 'Home',
        Earn: 'Share',
        Game: 'Game',
        Event: 'Event',
        Promotion: 'Promotion',
        Account: 'Profile',
        Recharge: 'Recharge',
        serve: 'Service',
        Deposit: 'Deposit',
        Affiliate: 'Affiliate'
    },
    home: {
        Download: 'Download',
        DownloadTips: 'Download the app and get ',
        Search: 'Search',
        SearchGames: 'Search Games',
        Popular: 'Popular',
        Recent: 'Recent',
        Favorite: 'Favorite',
        Providers: 'Providers',
        CollectionSucc: 'Collection successful',
        CollectionCanceled: 'Collection canceled',
        MORE: 'MORE',
        Top: 'Top',
        greatBonus: 'Great Bonus For Deposit',
        pullRefresh: 'Pull down to refresh...',
        releaseRefresh: 'Release to refresh...',
        loading: 'loading...',
        gameMoreTips1: 'Showing ',
        gameMoreTips2: ' games from ',
        gameMoreTips3: ' games'
    },
    login: {
        Login: 'Login',
        SignIn: 'Sign In',
        SignUp: 'Sign Up',
        RememberMe: 'Remember me',
        ForgetPassword: 'Forget password?',
        LoginTips: 'To visit this site, make sure you are over 18 and agree?',
        TermsOfService: 'Terms of Service',
        jumpRegister: 'Jump to registration',
        JumpLogin: 'Jump to login',
        noAccountTips: "Don't have an account?",
        hasAccountTips: 'Do you have an account?',
        Email: 'Email',
        VerificationCode: 'Verification code',
        Send: 'Send',
        RestPassword: 'Reset password',
        passwordTips: 'Password(6-16)',
        passwordTips2: 'Enter password again',
        password: 'Password',
        phone: 'Phone number',
        ReferralCode: 'Referral Code',
        CreateAccount: 'Create account',
        PleaseEnterYourPhoneNumber: 'Please enter your phone number',
        PleaseEnterYourPassword: 'Please enter your password',
        ThePasswordMustContain6To16Characters: 'The password must contain 6 to 16 characters',
        InconsistentPassword: 'The password do not match',
        PleaseEnterInvitationCode: 'Please enter invitation code',
        PleaseEnterEmail: 'Please enter your email account',
        PleaseEnterEmailFormat: 'Please enter the correct email format',
        day: 'day',
        also: 'also',
        downTime: 'Date from launch',
        changePwd: 'Change password',
        RechargeNow: 'Recharge Now',
        PlayGame: 'Registration successful! Play a game~',
        serviceTips: 'Please agree to the terms of service first',
        SuccessfullyClaimed: 'Successfully claimed',
        SuccessfullyClaimedTips1: '',
        SuccessfullyClaimedTips2: ' bonus will be distributed to the account',

        Account: 'Account',
        PleaseEnterAccount: 'Please enter Account',
        AccountFormat: 'Error in account format,6-16 characters, supports English/numbers',
        PhoneFormat: 'The format of the phone number you entered is incorrect',
        PleaseEnterPassword: 'Please Enter Password',
        PasswordFormat: 'At least 6 characters',
        ConfirmPassword: 'Confirm password',
        ConfirmPwdAgain: 'Confirm password again',
        InvitationCode: 'Invitation Code',
        PleaseEnteryourInvitationCode: 'Please enter your Invitation Code',
        OverAgeAgree: 'I am over 18 years old, read and accept',
        PleaseAgreeOverAge: 'First, check user agreement',
        RememberYouraccountPassword: 'Remember your account password',
        SelectCountry: 'Language',

        Reminder: 'Reminder',
        WantLogOutAccount: 'Do you want to log out of your account?',
        ConfirmExit: 'Confirm exit',
        Cancel: 'Cancel',

        Strength: 'Strength',
        sixteenDigits: '8-16 bits',
        UpperCaseletters: 'Upper case letters',
        LowerCaseLetters: 'Lower case letters',
        Numbers: 'Numbers',

        UNLOCK: 'UNLOCK',
        ENDLESSBENEFITS: 'ENDLESS    BENEFITS',
        loginTips1: 'Generous bonuses are ready! join us,find your own treasures',
        loginTips2: 'Exclusive VIP Event: Bet and Get Opportunities',
        loginTips3: 'Red envelope, daily regular payment',
        loginTips4: 'The benefits of inviting your friends to obtain treasure chests.',
        loginTips5: 'The benefits of logging in every day',
        loginTips6: 'When you make your first deposit, you can receive a bonus of up to 20%.',
        loginTips7: 'Upgrade to VIP to receive bonuses',
        loginTips8: 'Welcome to ',
        loginTips9: 'BRING you an unprecedented gaming experience',
        accountOrPhone: 'Account / Phone Number'
    },
    logout: {
        SignOut: 'Sign out',
        SignOutTips: 'Explore a world brimming with rewards and thrilling games!'
    },
    signin: {
        signInTitle: 'Daily Sign-in Bonus',
        signInDays: 'Continuously signed in for ',
        days: ' days',
        day: 'DAY',
        claimed: 'Claimed ',
        condition1: 'Required deposit',
        condition2: 'Required bets',
        eventDetails: 'Event Details',
        checkin: 'Check-in',
        CheckIn: 'CHECK IN',
        Today: 'Today',
        Uncompleted: 'UNCOMPLETED',
        Completed: 'COMPLETED',
        Conditions: 'Conditions',
        Rules: 'Rules',
        titleTips: 'actual, has been received during',
        Recarregue: 'Recharge',
        Aposte: 'Aposte',
        desc1: 'The current level can log in with a total of',
        desc2: 'days and receive',
        upBonusTitle: 'Congratulations on receiving a daily bonus of',
        upBonusDesc1: 'Simply deposit',
        upBonusDesc2: 'to increase your reward by',
        upBonusDesc3: 'times',
        upBonusGetNow: 'Get now',
        upBonusGet: 'Get',
        upBonusRedeemSuccess: 'Redeemed successfully',
        upBonusRedeemMessage: 'receive',
        upBonusConfirm: 'Confirm',
        navTitle: 'Check-in',
        buttonCheckIn: 'Check-In',
        continua: 'continúa mañana',
        Coleta: 'Coleta contínua',
        recompensas: 'Obter recompensas',
        Tempo: 'Tempo',
        buttonUnavailable: 'Conditions not met',
        DailyCashRewards: 'Daily cash rewards'
    },
    share: {
        panel: 'Panel',
        FAQ: 'FAQ',
        TUTORIAL: 'TUTORIAL',
        TotalRewards: 'Total Rewards',
        TotalFriends: 'Total Friends',
        inviteFriend: 'INVITE FRIENDS TO EARN',
        signUp: 'Sign Up & Earn',
        Commission: 'Commission',
        InviteVia: 'Invite via:',
        copy: 'Copy',
        link: 'Link',
        code: 'Code',
        or: 'OR',
        Rewards: 'Rewards',
        title1: 'COMMISSION',
        tip1: 'Earn up to',
        tip2: 'commission when your friend bet.',
        title2: 'DEPOSIT CASHBACK',
        tip3: 'Earn',
        tip4: 'when your friend deposit.',
        Details: 'Details',
        UncollectedCommissions: 'Uncollected commissions',
        ExclusiveCommission: 'Exclusive Commission',
        DepositCashback: 'Deposit cashback',
        Claim: 'Claim',
        TodayTeamData: 'Today team data',
        TotalTeamData: 'Total team data',
        SignUp: 'Sign Up',
        FirstDeposit: 'First Deposit',
        ValidBet: 'Valid bet',
        LiveRewards: 'Live Rewards',
        SendTotalCommission: 'Send total commission',
        rules: 'Rules',
        ruleInfo: 'You can make money by referring friends to and earn up to commission rewards！',
        Recommended: 'Recommended',
        Month: 'Month',
        UnlimitedSubordinates: 'Unlimited development of subordinates',
        planTitle: 'LEARN MORE ABOUT OUR AFFILIATE PROGRAM',
        planInfo: 'If you have a large audience and followers. We have special conditions for you to customize your referral program!',
        all: 'All',
        Direct: 'Direct',
        Indirect: 'Indirect',
        TodayTeamIntro1: 'Sign up:Number of users who signed up today',
        TodayTeamIntro2: 'First Deposit:Number of first deposit users today',
        TodayTeamIntro3: 'Valid bets:Valid betting for today’s team',
        TotalTeamIntro1: 'Sign up: Teams Total number of sign ups',
        TotalTeamIntro2: 'First Deposit: Total number of first-time depositors',
        TotalTeamIntro3: 'Valid bets:The team’s total effective bet amount',
        calculationRules: 'Commission calculation rules',
        rewardRules: 'Commission reward rules',
        ExtendRewardsBouns: 'Extend Rewards Bouns',
        GameBettingRewardsBouns: 'GameBetting Rewards Bouns',
        RechargeRewardsBouns: 'Recharge Rewards Bouns',
        Tier: 'Tier',
        intro1: 'Sign up:Number of users who signed up today',
        intro2: 'First Deposit:Number of first deposit users today',
        intro3: 'Valid bets:Valid betting for today’s team',
        intro4: 'Sign up: Teams Total number of sign ups',
        intro5: 'First Deposit: Total number of first-time depositors',
        intro6: 'Valid bets:The team’s total effective bet amount',
        rule1: ' Every time your recommended player places a bet, wins or loses, you will receive a different commission percentage.',

        startTime: 'start',
        endTime: 'end',
        TotalRewardAmount: 'Total reward amount:',
        // rules: '',
        level: 'level',
        Amount: 'amount',
        NumberOfPeople: 'Number of people',
        Part1Blogger: 'User rewards',
        FirstRewardAmount: 'First level member reward amount',
        FirstNumberOfPeople: 'Number of valid first level members',
        FirstRewardRatio: 'Reward ratio for first level valid members',
        FirstPaymentDiff: 'Payment difference of first level members',
        FirstRechargeAmount: 'Recharge amount for first tier members',
        FirstWithdrawalAmount: 'First level member withdrawal amount',
        Part2Partners: 'Partner rewards',
        PartnerRewardAmount: 'Partner Reward Amount:',
        PartnerRechargeAmount: 'Partner recharge amount:',
        PartnerWithdrawalAmount: 'Partner withdrawal amount:',
        FirstEffectiveNumber: 'Effective number of first level partners',
        SecondNumberOfPeople: 'Number of second level valid members',
        FirstPartnersRewardRatio: 'Reward ratio for first level partners',
        FirstPartnersRewardAmount: 'Reward amount for first level partners',
        FirstPartnersPaymentDiff: 'Payment difference of first level partner',
        SecondEffectiveRechargeAmount: 'Effective recharge amount for second level members',
        SecondEffectiveWithdrawalAmount: 'Effective withdrawal amount for second level members',
        SecondRechargeAmount: 'Recharge amount for second level members',
        SecondWithdrawalAmount: 'Second level member withdrawal amount',
        partnerRulesTips1_1: 'Improve recommendation rewards and increase the profit sharing of recommenders. Blogger A recommends blogger B, and A enjoys ',
        partnerRulesTips1_2: " of B's profit",
        partnerRulesTips1_3: '',
        partnerRulesTips2_1: 'The partnership rules require settlement ',
        partnerRulesTips2_2: 'once a day. ',
        partnerRulesTips2_3: 'once a week. ',
        partnerRulesTips2_4: 'once a month. ',
        partnerRulesTips2_5: 'Making the first recharge counts as a valid member',
        partnerRulesTips2_6: 'Recharge ',
        partnerRulesTips2_7: ' and place a bet of ',
        partnerRulesTips2_8: ' to be considered a valid member',
        ReachStandard: 'Number of people meeting the standard',
        RewardRatio: 'Reward ratio',
        partner: 'Partner',
        LowerLevelTeamData: 'Lower level team data',
        allData: 'All Data',
        yesterday: 'Yesterday',
        today: 'Today',
        thisWeek: 'This Week',
        lastWeek: 'Last Week',
        thisMonth: 'This Month',
        lastMonth: 'Last Month',
        validBets: 'Valid Bets',
        deposit: 'Deposit',
        myData: 'My Data',
        newSubordinates: 'New subordinates',
        firstDeposits: 'First Deposits',
        firstDepositAmount: 'First deposit amount',
        deposits: 'Deposits',
        withdrawalValue: 'Withdrawal Value',
        ValidBets: 'Valid Bets',
        receiveBonuses: 'Receive bonuses',
        performance: 'Performance',
        GLV: 'Gain/Loss Value',
        commission: 'Commission',
        dataSummary: 'Data summary',
        agentDataTip: "Summary of today's data after becoming an agent",
        teamSize: 'Team size',
        directMembers: 'Direct Members',
        OtherMembers: 'Other Members',
        fullPerformance: 'Full performance',
        direct: 'D. Direct',
        others: 'D. of Others',
        totalCommissions: 'Total Commissions',
        directCommission: 'Direct Commission',
        otherCommission: 'Other Commission',
        totalCommission: 'Total Commission',
        rescued: 'Rescued',
        notCollected: 'Not collected',
        directDepositTotal: 'Direct Report Deposit Total',
        directSubordinateWithdrawalsTotal: 'Direct total of subordinate withdrawals',
        directOrdersTotal: 'Total direct report orders',
        directValidBetsTotal: "Direct report's total valid bets",
        directGainToatl: 'Accumulated direct profit and loss',
        DirectRechargeAmount: 'Total Direct Recharges',
        OtherDeposits: 'Other Deposit',
        FirstDirectRecharge: 'First Direct Recharge',
        OtherInitialRefills: 'Other Initial Refills',
        TotalFirstDepositsPlayers: 'Total Players Making First Deposits',

        PromotedAccount: 'Promoted account',

        HowInvite: 'How to invite',
        DailyInvitation: 'Daily invitation',
        WheelFortune: 'Wheel of Fortune',
        WheelFortuneTips: 'Invite your friends to register and complete their recharge to receive a reward of up to ',
        InvitationRules: 'Invitation rules',
        ShareLinksTips: 'Share links through social media apps',
        CopyLinkToFriends: 'Copy the invitation link and send it to your friends.',
        InviteValidUsers: 'Invite valid users',
        getRewardsTimeTips: 'Rewards will be distributed at 00:00 the next day.',
        EarnRewards: 'Earn rewards',
        ImportantNotice: 'Important Notice:',
        ImportantNoticeContent: 'To ensure fairness on the platform, we have implemented anti-cheating measures. Users who cheat will have their accounts permanently suspended, their illicit funds frozen, and will be held legally responsible.',

        rule2: '🎉 Rewards Invitation 🎉',
        rule3: '🔥 Invite your friends and earn nonstop!',
        rule4: '👉 📱 When your friend registers with their phone number and completes their first top-up, they will become a valid user.',
        rule5: '💎 For every valid user you invite → you’ll receive an instant reward!',
        rule6: '🚀 The more you invite, the more you earn — there’s no limit!',
        rule7: '✨ Share with your friends right now and don’t let the rewards slip away! 🎁🎊',

        Invite: 'Invite',
        bonus: 'bonus',

        TotalPrize: 'Total prize',
        BonusesAlreadySettled: 'Bonuses already settled',
        BonusPendingSettlement: 'Bonus pending settlement',
        UpdateEveryHours: 'Update every 24 hours',
        TotalData: 'Total data',
        RewardsFirstRecharge: 'Rewards for first recharge',
        TotalReward: 'Total reward',
        DailyData: 'Daily data',
        Data: 'Data',
        RechargeUser: 'Recharge user',
        FirstRechargeRewards: 'First recharge rewards',
        AmountCollectedBehalf: 'Deposit amount',
        CollectionPersonCount: 'Number of depositors',
        SaveImage: 'Save image',
        reward: 'reward'
    },
    deposit: {
        PaymentMethodsRregion: 'Payment methods for the region',
        DepositMethods: 'Deposit methods',
        Deposit: 'Deposit',
        FirstDeposit: 'Deposit bonus',
        Details: 'Details',
        Amount: 'Amount',
        Extra: 'Extra',
        noBonus: 'no bonus',
        PleaseEnterDeposit: 'Please enter deposit amount',
        isMinRechargeAmtTips: 'The recharge amount must be greater than the minimum recharge amount',
        isMaxRechargeAmtTips: 'The recharge amount must be less than the maximum recharge amount',
        showBonusTips: 'Do not participate in deposit promotions',
        rewardPercentageTxt1_1: 'Over',
        rewardPercentageTxt1_2: 'plus',
        rewardPercentageTxt1_3: '%',
        rewardPercentageTxt2_1: 'Daily First Fill ',
        rewardPercentageTxt2_2: '+',
        rewardPercentageTxt2_3: '%',
        rewardPercentageTxt3_1: 'Registration first fill ',
        rewardPercentageTxt3_2: '+',
        rewardPercentageTxt3_3: '%',
        Change: 'Change',
        DepositBonus: 'Deposit Bonus',
        DepositAmount: 'Deposit Amount',
        Bonus: 'Bonus',
        DepositTips: 'Platform deposits offer generous rewards, with a specified amount of money deposited each time to receive a bonus.',
        DepositTips2: 'Please use T-bank or Sber for recharging, as other banks do not currently support it.',
        howTitle: 'How to Claim the Deposit Bonus?',
        Step: 'Step',
        Step2Title: 'Claim deposit bonus',
        howTips1: 'Go to deposit. Choose your preferred deposit method to make a deposit.',
        howTips2: 'After the deposit is completed, you will receive the corresponding bonus based on the deposit amount and bonus ratio.',
        TransferDeposit: 'USDT Deposit',
        OnlineDeposit: 'Online Deposit',
        ExchangeRate: 'Exchange rate',
        Tutorial: 'USDT recharge tutorial',
        TransferAmount: 'Transfer amount :',
        TargetAccount: 'Target account :',
        showTips: 'After the system detects your transfer, it will increase your balance',
        transferred: 'I have transferred the money',
        information: 'Transfer information',
        name: 'Payee name :',
        bank: 'bank :'
    },
    DepositDetails: {
        DepositDetails: 'Deposit Details',
        WaitingForPayment: 'Waiting for payment.',
        countDownTxt1: 'Please',
        countDownTxt2: 'complete the deposit',
        ExchangeRate: 'Exchange rate',
        DepositMethod: 'Deposit Method',
        Currency: 'Currency',
        MainnetProtocol: 'Mainnet Protocol (the network channel, very important)',
        PaymentAddress: 'Payment Address',
        CreationTime: 'Creation Time',
        OrderNumber: 'Order Number',
        TransactionRemark: 'Transaction remark',
        cashAddress: 'cash address',
        DepositTips1: "1. Please ensure the correct amount after deducting the withdrawal fee (the correct received amount) to complete the transaction; otherwise, the deposit won't be successful.",
        DepositTips2: "2. Confirm that the mainnet protocol you are transferring/depositing matches the mainnet protocol you have selected. Otherwise, the deposit/transfer won't be successful or will be refunded.",
        DepositTips3: '3. Only supports USDT. Please do not transfer other currencies to this address.',
        cancelBtn: 'cancel an order',
        TransferredBtn: 'I Have Transferred',
        ContinueBtn: 'Continue to Deposit',
        hashAddress: 'Hash address',
        pleasetEnterHashAddress: 'pleaset enter hash address',
        cancelOrderTips: 'Do you want to cancel this payment order?',
        waitPayTips: 'There are currently unpaid orders, would you like to proceed with payment?'
    },
    Withdraw: {
        currency: 'currency',
        Withdraw: 'Withdraw',
        BalanceRecords: 'Balance records',
        chooseAmountTitle: 'Choose or enter amount',
        needBonus: 'I need bonus',
        DepositAmount: 'Deposit Amount',
        Bonus: 'Bonus',
        TotalReceive: 'Total Receive',
        PAY: 'PAY',
        PaymentProblem: 'Payment problem',
        ClickForHelp: 'Click for help',
        DepositNotes: 'Deposit Notes',
        BalanceWithdraw: 'Balance Withdraw',
        BonusWithdraw: 'Bonus Withdraw',
        ChooseFundsType: 'Choose Funds Type',
        BettingLootRelease: 'Betting loot release',
        MinimumWithdrawal: 'Minimum withdrawal',
        WithidrawLimitPerday: 'Withdrawal limit perday',
        WithdrawTimePerday: 'Withdrawal time perday',
        TotalBalance: 'Total Balance',
        TotalBonus: 'Total Bonus',
        WithdrawableBalance: 'Withdrawable Balance',
        WithdrawableBonus: 'Remaining bonus',
        WithdrawAmount: 'Withdraw amount',
        All: 'All',
        ChooseYourBankcard: 'Choose your bankcard',
        AddABankCardFirst: 'Add a bankcard first',
        WithdrawPassword: 'Withdraw Password',
        InputWithdrawPassword: 'Input withdraw password',
        Fee: 'Fee',
        commission: 'Commission',
        Receive: 'Receive',
        WithdrawNotes: 'Withdraw Notes',
        WithdrawNotesInfo: 'Note: 3%+6Rs of the withdrawal amount will be deducted as bank commission Please double check the withdrawal information, if withdrawal failed or you have any other questions, please contact CS 24/7',
        WithdrawalDetails: 'Withdrawal details',
        PleaseEnterDeposit: 'Please enter deposit amount',
        PleaseEnterWithdraw: 'Please enter withdraw',
        withdrawalAmountMust10: 'The withdrawal amount must be a multiple of 10.',
        PleaseChooseBank: 'Please enter the bank card information first',
        PleaseEnterWithdrawPassword: 'Please enter withdraw password',
        PleaseEnterInteger: 'Please enter an integer for the withdrawal amount',
        PleaseEnterMiniWithdrawPrice: 'The withdrawal amount cannot be less than the minimum withdrawal amount',
        PleaseEnterMaxWithdrawAmt: 'The withdrawal amount cannot exceed the maximum withdrawal limit',
        notInTime1: 'Withdrawal time available:',
        notInTime2: 'System settlement time:',
        notInTime3: 'After the start of the withdrawal, the amount will reach the account within 24 hours of the start of the withdrawal. If you have any questions, please contact our customer support.',
        NotDealWith: 'In progress',
        withdrawTips: 'All referral rewards and comission will be paid as bonus. The bouns can be withdrawn directly. It can also be converted into balance.',
        ExtraBonus: 'Extra bonus: ',
        ratetxt1: 'I also need to bet',
        ratetxt2: 'to withdraw',
        ratetxt3: ' still require a bet of ',
        ratetxt4: ' to withdraw',
        ratetxt5: 'Failure to meet withdrawal requirements.',
        VerifyIdentity: 'Verify identity',
        ChooseDepositType: 'Choose deposit type',
        TransferDeposit: 'Transfer Deposit',
        OnlineDeposit: 'Online Deposit',
        EnterAmount: 'Enter amount',
        isMinRechargeAmtTips: 'The recharge amount must be greater than the minimum recharge amount',
        isMaxRechargeAmtTips: 'The recharge amount must be less than the maximum recharge amount',
        rewardPercentageTxt1_1: 'Over',
        rewardPercentageTxt1_2: 'plus',
        rewardPercentageTxt1_3: '%',
        rewardPercentageTxt2_1: 'Daily First Fill ',
        rewardPercentageTxt2_2: '+',
        rewardPercentageTxt2_3: '%',
        rewardPercentageTxt3_1: 'Registration first fill ',
        rewardPercentageTxt3_2: '+',
        rewardPercentageTxt3_3: '%',
        Illustrate: 'Illustrate',

        Today: 'Today',
        Yesterday: 'Yesterday',
        Week: 'Week',
        thisWeek: 'this Week',
        lastWeek: 'last Week',
        Month: 'Month',
        thisMonth: 'this Month',
        lastMonth: 'last Month',
        RequestWithdrawal: 'Request withdrawal',
        WithdrawalAmount: 'Withdrawal amount',
        BettingRecords: 'Betting records',
        AuditRecords: 'Audit Records',
        WithdrawalRecord: 'Withdrawal Records',
        BetRecordTips1: 'You also need to effectively bet ',
        BetRecordTips2: ' to withdraw money!',
        GameName: 'Game Name',
        TotalWithdrawal: 'Total withdrawal',
        TypeBalance: 'Type of balance',
        RemainingBalance: 'Remaining balance',

        NoBankTips: 'No withdrawal password and bank card have been set, please go to the settings.',
        DepositTips: 'Reminder:Dear Customer: Hello! In order for you to withdraw money to your account in good time, make sure you fill in a true and valid account number and name and carefully check if they are correct, thank you!',
        withdrawTips1: 'Terms of Use: Dear customers, for the safety of your funds and the timely arrival of funds, please check again whether your receiving account is correct.',
        PleaseEnterWithdrawAmt2: 'Please enter the withdrawal amount',
        ManageAccount: 'Manage Account',
        Add: 'Add',
        SetDefault: 'Set as default',

        InsertPassword: 'Insert Password',
        withdrawPwdPopupTips: 'For the security of your account, enter the withdrawal password',

        TransferDigital: 'Transfer to digital currency',
        Focus: 'Focus',
        OnlineWithdraw: 'Online Withdraw',
        TransferWithdraw: 'USDT Withdraw',
        USDTPaymentAddress: 'USDT payment address',
        PleaseEnterUSDTPaymentAddress: 'Please enter USDT payment address',
        WithdrawTips1: 'Withdrawal discount: Withdrawals are not available on Fridays, Saturdays, and Sundays. If you want to withdraw funds within these three days, we recommend using USDT. USDT funds will arrive in your account within 10 minutes! If your funds do not reach your account within 10 minutes, please be patient and users must review them one by one. If you have any questions, please contact support.',
        WithdrawTips2: 'Withdrawal Guidelines: A minimum of ',
        WithdrawTips3: ' is required for withdrawals to a bank card, while a minimum of ',
        WithdrawTips4: ' is needed for USDT withdrawals. Funds will be credited to your bank card within 24 hours! USDT withdrawals are processed within 10 minutes!',
        disabledWithdraw: 'The current account withdrawal function has been disabled. Please contact customer service!', // 当前账户禁止提现
        BalanceUnavailable: 'Balance unavailable'
    },
    bankset: {
        BankCardDetails: 'Bank Card Details',
        Type: 'Type',
        AccountName: 'Account name',
        NameOfTheAccountHolder: 'Name of the account holder',
        PIXAccount: 'PIX Account',
        InputPIXAccount: 'Input PIX account',
        CPFAccount: 'CPF Account',
        PleaseEnterCPF: 'Please enter CPF',
        WithdrawPassword: 'Withdraw Password',
        InputWithdrawalPassword: 'Enter withdrawal password',
        ConfirmWithdrawalPassword: 'Confirm withdrawal password',
        PleaseEnterWithdrawPassword: 'Please enter withdraw password',
        InputConfirmWithdrawalPassword: 'Enter the confirmation withdrawal password',
        ChooseCertificateType: 'Choose certificate type',
        InputAccountName: 'Enter Account name',
        InputInconsistentWithdrawPassword: 'Inconsistent Withdraw Password input',
        PayeeAccount: 'beneficiary account no',
        BankName: 'Bank name',
        bankCardNumber: 'bank card number',
        TaxID: 'Tax ID',
        PleaseEnterTaxID: 'Please enter Tax ID',
        TaxIDTips: 'Please enter a 12 or 13 character tax number',
        ChooseBank: 'Choose a bank',
        PleaseSelectBank: 'Please select a bank',
        AccountPhone: 'Phone number',
        EnterPhoneNumber: 'enter phone number',
        PleaseEnterPhoneNumber: 'Please enter your phone number',
        email: 'E-mail',
        PleaseEnterEmail: 'Please enter your email address',
        EmailFormat: 'Email format incorrect',
        InputPayeeAccount: 'Please enter the receiving account number',
        PleaseSelectChannelName: 'Please select channel name',
        Save: 'Save',
        PayeeAccountTips1: 'Please enter an 10 digit phone number',
        PayeeAccountTips2: 'Please enter a 16 digit bank card number',
        PayeeAccountTips3: 'Please enter a 18 digit bank card number',
        WithdrawTips: 'Please enter the phone number bound to T-bank for withdrawal. Other banks currently do not support it',
        PIXAccountCNPJ: '11 digits, format***.***.***-**',
        ConfirmPIXAccount: 'Confirm PIX Account',
        NamePayee: 'Name of payee',
        phoneNumber: 'cell-phone number',
        VerificationCode: 'Verification Code',
        InputPIXAccountAgain: 'Input PIX account again',
        InputBankIFSC: 'Input Bank IFSC',
        InputNamePayee: 'Enter payee name',
        InputVerificationCode: 'Enter Verification Code',
        CPFAccountCNPJ: 'Enter the company code',
        ConfirmCPFAccount: 'Confirm CPF Account',
        Tips: 'Need to change? Contact customer service',

        AccountType: 'Account type',
        PleaseSelectAccountType: 'Please select account type',
        ChannelName: 'Channel Name',
        IDCard: 'ID card',
        PleaseEnterIDCardNo: 'Please enter the ID card no',
        IDCardNo13Int: 'The ID card number must be 13 pure digits',
        Payee10Int: "The recipient's account must be a ten digit pure number starting with 3",

        linkBankTips: 'Account not linked to bank card, please go to link it',
        PhoneFormatPeru: 'The phone number must be a 9-digit pure number',

        InterbankAccountCode: 'Interbank account code',
        PleaseEnterInterbankAccountCode: 'Please enter Interbank account code',

        IdentityType: 'Identity type',
        PleaseSelectIdentityType: 'Please select identity type',

        IDNumber: 'ID number',
        PleaseEnterIDNumber: 'Please enter your identification number',
        WithdrawalAccount: 'Withdrawal Account',

        banksetPopupTips1: 'PIX account of type pix-CPF can only be added;',
        banksetPopupTips2: 'Check carefully, otherwise you will not be credited.',
        banksetPopupTips3: 'Confirm name and card to ensure funds are credited.',
        PhoneFormatBrazil: 'cell-phone number 8-14 Digits',
        WrongWithdrawalPassword: 'Wrong withdrawal password',
        PleaseEnterIDCardName: 'Fill in the real name and make it convenient for later withdrawal!',
        DebitCard: 'Debit Card'
    },
    withdrawPwd: {
        title: 'Withdrawal password',
        withdrawPwdTips1: 'To ensure the safety of your funds, you first need to set a withdrawal password!',
        withdrawPwdTips2: 'Set your withdrawal password',
        withdrawPwdLabel1: 'New withdrawal password',
        withdrawPwdLabel2: 'Confirm your withdrawal password',
        withdrawPwdTips3: 'Attention: It is very important to protect your funds with a withdrawal password. Keep it a secret to avoid any financial losses.',
        notContinuousNumbers: "Can't be 6 same or continuous numbers",
        PleaseEnterWithdrawalPassword: 'Please enter withdrawal password',
        ConfirmWithdrawalPassword: 'Confirm withdrawal password',
        InputInconsistentWithdrawPassword: 'Inconsistent Withdraw Password input'
    },
    Notification: {
        Notification: 'Notification',
        news: 'News',
        nomore: 'No more'
    },
    bonusCenter: {
        BonusDetails: 'Bonus Details',
        BonusCategories: 'Bonus Categories',
        WeeklyBonus: 'Weekly Bonus',
        MonthlyBonus: 'Monthly Bonus',
        LevelupBonus: 'Level up Bonus',
        BonusRain: 'Red Packet',
        DepositBonus: 'Deposit Bonus',
        SpecialBonus: 'Special Bonus',
        BonusTransactions: 'Bonus Transactions',
        BonusType: 'Bonus Type',
        ClaimedAmount: 'Claimed Amount',
        Time: 'Time',
        OopsNodatayet: 'Oops! No data yet!',
        TotalBonusClaime: 'Total Bonus Claimed',
        TotalGeneralBonus: 'Activity bonus',
        TotalVIPBonus: 'Total VIP Bonus',
        rechargeBonus: 'Recharge bonus',
        Details: 'Details',
        TotalBonus: 'Total Bonus:',
        Rules: 'Rules',
        Bonusends: 'Bonus ends:',
        DepositNow: 'Deposit Now',
        Generalbonus: 'General bonus',
        Todayevents: 'Today’s events',
        Nextrain: 'Next time',
        CheckIn: 'Check In',
        Counts: 'Counts',
        Deposit: 'Deposit',
        VIPBonus: 'VIP Bonus',
        Levelupbonus: 'Level up bonus',
        XPtoVIP: 'XP to VIP',
        UpgradeBonus: 'Upgrade Bonus',
        NextLevelBonus: 'Next level Bonus',
        ViewVIPClub: 'View VIP Club',
        Wager: 'Wager',
        VIP: 'VIP',
        Unlockendless: 'Unlock endless benefits',
        Generousbonuses: 'Generous bonuses are ready! Join us.Find your own treasures.',
        JoinNow: 'Join Now',
        Upgradebonuses: 'Upgrade VIP to get bonuses',
        Invitefriendss: 'Invite friends to play games and get bonuses',
        Completequest: 'Complete quest to get bonuses',
        Winbigwith: 'Win big with our weekly and monthly bonuses!',
        Discover: 'Discover extraordinary bonus',
        numerousbonuses: 'We offer numerous bonuses to every user. There are new rewards every day and every week.',
        Signbonus: 'Sign up and get bonus',
        LevelupVIP: 'Level up VIP, more rewards!',
        VIPstatusmeans: 'VIP status means more value here. You can quickly build wealth and create a solid financial base byunlocking its perks.',
        Whatget: 'What do VIPs get?',
        Saygoodbye: 'Say goodbye to ordinary gaming, hello to pure luxury.',
        RedeemBonusCode: 'Redeem Bonus Code',
        RedeemCode: 'Redeem Code',
        AllBonuses: 'All bonuses',
        eventManage: 'Activity bonus',
        VIPCycleReward: 'VIP level reward',
        Extend: 'Promotion bonus',
        reliefMoneyEvent: 'Rescue gold activity',
        singInEvent: 'Sign in activity',
        luckyWheelEvent: 'Lucky Wheel Activity',
        redPacletEvent: 'Red packet activity',
        gameBettingEvent: 'Game betting activity',
        pinduoduoEvent: 'Invitation activities',
        rankingListEvent: 'Ranking activity',
        registerRewardsEvent: 'Registration Activity',
        VIPWeeklyReward: 'VIP Weekly Rewards',
        VIPMonthlyReward: 'VIP Monthly Rewards',
        VIPLevelUpReward: 'VIP level reward',
        Redeemyour: 'Redeem your bonus code below.',
        Redeem: 'Redeem',
        Unlocked: 'Unlocked',
        RechargeAmount: 'Recharge amount',
        RegisterAndObtain: 'Register and obtain',
        bonus: 'Bonus',
        FreeSpins: ' Free Spins',
        depositBonusTips: ' - online casino with instant payouts where your favorite streamers play',
        GetBonus: 'Get a bonus',
        depositBonusTips2: 'Register and access bonuses',
        depositBonusTips3: 'Each time you replenish your balance, you receive a bonus of ',
        depositBonusTips4: '% in total, if all ',
        depositBonusTips5: ' deposits are taken into account.',
        depositBonusTips6: ' (Free Spins Game: Big Bass Christmas Bash)',
        thDeposit: 'th deposit'
    },
    lossSupport: {
        title: 'Loss Support',
        lossSupport: 'Support',
        yesterdayLoss: "Yesterday's losses",
        todayBonus: "Today's Support Bonus",
        loseMoney: 'Amount of loss',
        extraprizes: 'Extra prizes',
        amountDamage: 'amount of damage',
        AmountReward: 'Amount of reward',
        EventIntro: 'Event Instructions：',
        VIPLevel: 'VIP level'
    },
    rebate: {
        title: 'Rebates on bets',
        BettingVolume: 'Betting volume',
        RewardAmount: 'Reward amount',
        EventIntro: 'Event Instructions：'
    },
    downApp: {
        downAppSuccTips: 'You have successfully installed the application.',
        downAppSuccTips2: 'You have already installed the application. Or click the download button icon in the upper right corner of the browser URL address to reinstall.',
        SaveVersionDesktop: 'Save web version to desktop',
        SaveVersionTips: 'Click to quickly download the application to your desktop',
        QuickVersion: 'Quick version',
        NormalVersion: 'Normal version',
        download: 'Download',
        NotInDevice: 'Not compatible with this device',
        Games: 'Games',
        Apps: 'Apps',
        Movies: 'Movies',
        Books: 'Books',
        Kids: 'Kids',
        ProductMadness: 'Product Madness',
        InAppPurchases: 'In-app purchases',
        reviews: 'reviews',
        Downloads: 'Downloads',
        Install: 'Install',
        Share: 'Share',
        AddToWishlist: 'Add to wishlist',
        appAvailableDevice: 'This app is available for your device',
        AboutGame: 'About this game',
        comment1: 'Experience the thrill of cards and the excitement of high-stakes gambling in gd-goatbet! Join a vibrant community of card enthusiasts in this immersive and social card game. Play Teen Patti in various modes, engage in thrilling tournaments, and rise to become the ultimate gd-goatbet. With its authentic gameplay, social features, and competitive spirit, gd-goatbet offers a captivating card-playing experience that will keep you coming back for more.',
        comment2: '1.Authentic Teen Patti Experience: Immerse yourself in the authentic and traditional Teen Patti card game, featuring realistic rules and engaging gameplay.',
        comment3: '2.Diverse Game Modes: Explore a variety of game modes, from classic Teen Patti to innovative variations, providing a dynamic and entertaining gaming experience.',
        comment4: '3.Social Card Gaming: Connect with friends, join clubs, and engage in multiplayer matches, fostering a social and interactive gaming environment.',
        DataSafety: 'Data safety',
        comment5: 'Safety starts with understanding how developers collect and share your data. Data privacy and security practices may vary based on your use, region, and age. The developer provided this information and may update it over time.',
        comment6: 'This app may share these data types with third parties',
        comment7: 'Location,Personal info and 6 others',
        comment8: 'This app may collect these data types',
        comment9: 'Location, Personal info and 6',
        comment10: 'Data is encrypted in transit',
        comment11: 'You can request that data be deleted',
        SeeDetails: 'See details',
        RatingsAndReviews: 'Ratings and reviews',
        Phone: 'Phone',
        Tablet: 'Tablet',
        October: 'October',
        comment12: "Great choice of popular games that are also in the casinos live, and lots of fun to play! Watching ads alone can sustain play, but can be agonizingly slow at times. Be prepared to make purchases or have lots of patience. Sometimes, you have to watch a 30 second to a minute long ad in between a few hands of play, and that can go on for several hands. On some games, you can't complete the bonus requirements unless you buy money to play. STILL, my favorite of all the casino apps to play!",
        comment13: '3,394 people found this review helpful',
        comment14: 'Did you find this helpful?',
        Yes: 'Yes',
        No: 'No',
        September: 'September',
        comment15: 'I really enjoy this game. It has a variety of different slots to play. I can earn extra coins as I play. Not many ads to watch. The amount of coins when buying is lower than other games, but due to the quality of this game, they are worth it in my opinion. I have downloaded and then deleted other apps after playing them.',
        comment16: '1,110 people found this review helpful',
        comment17: 'Did you find this helpful?',
        WhatNew: "What's new",
        comment18: 'Get our NEW games in our latest update!',
        comment19: 'For the best experience and most FUN we’ve squashed bugs and optimized your game.',
        AppSupport: 'App support',
        SimilarGames: 'SimilarGames',
        LightningLinkCasinoSlots: 'Lightning Link Casino Slots',
        QuickHitCasinoSlotGames: 'Quick Hit Casino Slot Games',
        SciPlay: 'SciPlay',
        LuckyTimeSlots: 'Lucky Time Slots',
        DGNGames: 'DGN Games',
        CashTornadoSlotsCasino: 'Cash Tornado™ Slots - Casino',
        ZerooGravityGames: 'Zeroo Gravity Games',
        GoldFishCasinoSlot: 'Gold Fish Casino Slot',
        FlagInappropriate: 'Flag as inappropriate',
        GooglePlay: 'Play',
        PlayPass: 'Play Pass',
        PlayPoints: 'Play Points',
        GiftCards: 'Gift cards',
        Redeem: 'Redeem',
        RefundPolicy: 'Refund policy',
        KidsFamily: 'Kids  family',
        ParentGuide: 'Parent Guide',
        FamilySharing: 'Family sharing',
        TermsService: 'Terms of Service',
        Privacidade: 'Privacidade',
        SobreGooglePlay: 'Sobre o Play',
        Desenvolvedores: 'Desenvolvedores',
        GoogleStore: 'Store',
        UnitedStates: 'United States (English)',

        AppStore: 'App Store',
        DesignedIPhone: 'Designed for iPhone',
        get: 'get',
        iPhoneScreenshots: 'iPhone Screenshots',
        AppPrivacy: 'App Privacy',
        intro1: 'The developer, ',
        intro2: ', indicated that the app’s privacy practices may include handling of data as described below. For more information, see the ',
        intro3: 'developer’s privacy policy',
        intro4: 'Data Not Collected',
        intro5: 'The developer does not collect any data from this app.',
        intro6: 'Privacy practices may vary, for example, based on the features you use or your age. ',
        intro7: 'Information',
        Seller: 'Seller',
        Size: 'Size',
        Category: 'Category',
        Compatibility: 'Compatibility',
        iPhone: 'iPhone',
        support1: 'Requires iOS 10.0 or later.',
        iPodTouch: 'iPod touch',
        support2: 'Requires iOS 10.0 or later.',
        Mac: 'Mac',
        support3: 'Requires macOS 11.0 or later and a Mac with Apple M1 chip or later.',
        Languages: 'Languages',
        EnglishSimplifiedChinese: 'English, Simplified Chinese',
        AgeRating: 'Age Rating',
        UnrestrictedWebAccess: 'Unrestricted Web Access',
        InfrequentMildHorrorFearThemes: 'Infrequent/Mild Horror/Fear Themes',
        Copyright: 'Copyright',
        Price: 'Price',
        Free: 'Free',
        PrivacyPolicy: 'Privacy Policy',
        Supports: 'Supports',
        GameCenter: 'Game Center',
        GameCenterTips: 'Challenge friends and check leaderboards and achievements.',
        Morewaysshop: 'More ways to shop',
        FindAppleStore: 'Find an Apple Store',
        or: 'or',
        otherRetailer: 'other retailer',
        nearYou: 'near you. ',
        OrCall: 'Or call 1-800-MY-APPLE.',
        ChooseYourCountryRegion: 'Choose your country or region',
        TermsUse: 'Terms of Use',
        SalesRefunds: 'Sales and Refunds',
        Legal: 'Legal',
        SiteMap: 'Site Map',
        ClickButtonToDownload: 'Download the app for safer withdrawals',
        ClickButtonToDownload2: 'Download the app to play games',
        ApplicableWindows: 'Applicable to Windows',
        ApplicableWindowsTips: 'Add Quick Access to the Desktop'
    },
    event: {
        Detail: 'Detail',
        greatBonus: 'Great Bonus For ',
        everyDeposit: 'Every Deposit',
        firstDeposit: 'First Deposit',
        secondDeposit: 'Second Deposit',
        thirdDeposit: 'Third Deposit',
        upTo: 'Up to',
        allPlayers: 'Available for all players ',
        before: 'Before',
        Bonus: 'Bonus',
        Deposit: 'Deposit',
        Recompensas: 'Special rewards',
        preparado: 'Weve prepared many bonuses for you, so dont miss out! Come and claim them!',
        RewardReceived: 'Reward received',
        redPacketBtnsName: 'Open at the designated time'
    },
    person: {
        Bets: 'Bets',
        Balance: 'Balance',
        Bonus: 'Bonus',
        Transaction: 'Transaction',
        History: 'History',
        Welcome: 'Welcome to ',
        signIn: 'Please Sign up or Sign in first',
        invite: 'Invite friends',
        redPacket: 'Red Packet',
        Notification: 'Notification',
        Promotion: 'Promotion',
        VIPClub: 'VIP Club',
        LiveChat: 'Live Chat',
        AccountSettings: 'Account settings',
        Install: 'Install',
        BonusTransfer: 'Bonus transfer',
        transferMsg: 'The bonus is insufficient.',
        transferTips1: 'Do you want to transfer ',
        transferTips2: ' bonus to balance?',
        transferTips3: 'Transfer now',
        InvitationCenter: 'Invitation Center',
        PersonalCenter: 'Personal Center',
        VIPNeed: 'Requirements to upgrade to VIP',
        AccountTotal: 'Account Total'
    },
    Vip: {
        VIPSupport: 'VIP support',
        LevelBenefits: 'VIP Level & Benefits',
        Deposits: 'Deposits',
        Bets: 'Bets',
        or: 'or',
        to: 'to',
        joinClub: 'Join the VIP Club. Unlock High Cashbacks.All kinds of exquisite gifts.It will surprise you!',
        levelUp: 'Level Up to VIP',
        Steps: 'Steps',
        Benefits: 'Benefits',
        benefits1: 'Level up bonus',
        benefits2: 'Weekly bonus',
        benefits3: 'Monthly bonus',
        info1: 'VIP level up to get bonus!',
        info2: 'Claim free bonus every week.',
        info3: 'Claim free bonus every month.',
        More: 'More',
        promotionTip: 'Please see our promotions for more details.',
        Promotions: 'Promotions',
        FAQ: 'FAQ',
        question1: '1.What is "Level-Up Bonus"?',
        answer1: ' A "level-up bonus" is a VIP perk where rewards increase as you advance to higher VIP levels.',
        question2: '2.Benefits of upgrading VIP',
        answer2: 'Upgrading your VIP can get higher withdrawal amount and lower withdrawal fee!',
        LevelUpBonus: 'Level up bonus',
        WeeklyBonus: 'Weekly bonus',
        MonthlyBonus: 'Monthly Bonus',
        Level: 'Level',
        RequiredDeposit: 'Required Deposit',
        RequiredBet: 'Required Bet',
        Get: 'Get',
        UpgradeBonus: 'Upgrade bonus',
        vipRewards: 'Sign Up & Get Exclusive VIP Rewards!',
        earnPoints: 'Bet and earn points!',
        levelUpBenifits: 'Unlock Rewards, Level Up Your Benefits!',
        Step1: 'Step1',
        Step2: 'Step2',
        Step3: 'Step3',
        LevelReward: 'Level Reward',
        UpgradeYourVIPLevelReceiveRewards: 'Upgrade your VIP level to receive rewards.',
        TotalCheckInRewards: 'Total check-in rewards',
        WeeklySalary: 'Weekly salary',
        DistributedAutomaticallyEveryWednesday: 'Distributed automatically every Wednesday.',
        LossSubsidy: 'Loss subsidy',
        DistributedAutomaticallyEveryMonday: 'Distributed automatically every Monday',
        Withdraw: 'Withdraw',
        MaximumSingleWithdrawalLimit: 'Maximum single withdrawal limit',
        NumberWithdrawalsPerDay: 'Number of withdrawals per day',
        CheckIn: 'Check-in',
        KeepYourVipLevel: 'Keep your VIP level!',
        KeepVipLevelDescription: 'Play every month to maintain your current VIP level. Prolonged inactivity will automatically trigger a demotion. Keep playing and enjoy premium privileges without losing your VIP level!',
        KeepVipLevelDuring: 'Maintain VIP level during',
        RechargeAmount: 'Recharge amount',
        BetAmount: 'Bet amount'
    },
    MyProfile: {
        Profile: 'Profile',
        ID: 'ID',
        Join: 'Join',
        TotalBet: 'Total Bet',
        TotalBonus: 'Total Bonus',
        FavoriteGames: 'Favorite Games'
    },
    Transaction: {
        Transaction: 'Transaction',
        TotalAmount: 'Total Amount',
        DepositValue: 'Deposit value',
        Bonus: 'Bonus',
        Received: 'Received',
        WithdrawBonus: 'Withdraw bonus',
        Rate: 'Rate',
        Today: 'Today',
        Yesterday: 'Yesterday',
        LastThreeDays: 'Last 3 days',
        LastSevenDays: 'Last 7 days',
        LastFifteenDays: 'Last 15 days',
        LastThiryDays: 'Last 30 days',
        AllState: 'All State',
        Processing: 'Processing',
        Successful: 'Successful',
        Failed: 'Failed',
        WithdrawFail: 'Withdraw Fail',
        Withdrawing: 'Withdrawing',
        WithdrawSuccess: 'Withdraw Success',
        PaySuccess: 'Pay Success',
        Paying: 'Paying',
        Fail: 'Fail',
        WaitPay: 'WaitPay',
        Cancel: 'Cancel'
    },
    BetsHistory: {
        BetsHistory: 'Bets History'
    },
    Setting: {
        Setting: 'Setting',
        LiveChat: 'Live Chat ',
        AccountID: 'Account ID',
        PhoneNumber: 'Phone Number',
        Password: 'Password',
        Change: 'Change',
        oldPasswordTips: 'enter the original password',
        PleaseEnterYourOriginalPassword: 'Please enter your original password',
        passwordTips: 'Password(6-16)',
        PleaseEnterYourNewPassword: 'Please enter your new password',
        passwordTips2: 'Enter password again',
        PleaseEnterYourNewPasswordSure: 'Please enter your new password again',
        changePwd: 'Change password'
    },
    RedPacket: {
        RedPacket: 'Red Packet',
        NextEvent: 'Next Event',
        Participate: 'Participate'
    },
    turntable: {
        Roulette: 'Roulette',
        lottery: 'Lottery',
        title: 'Jackpot Wheel of Fortune',
        totalTips1: 'Current lucky points ',
        totalTips2: 'You still need to bet ',
        totalTips3: ' to get ',
        totalTips4: ' Lucky Points',
        totalTips5: 'Daily first charge can earn ',
        totalTips6: ' lucky points',
        totalTips7: 'A single recharge of ',
        totalTips8: ' or more grants one lottery draw, with no limit on the number of draws',
        totalTips9: 'The amount earned can be withdrawn once it exceeds ',
        totalTips10: 'Have you run out of free spins? Invite your friends to sign up and earn extra spins.',
        totalTips11: 'You can win up to ',
        totalTips12: ' in prizes!',
        totalTips13: 'Welcome to the Wheel of Fortune.',
        totalTips14: 'Claim your generous bonus!',
        totalTips15: 'You have completed ',
        totalTips16: ',you only need ',
        totalTips17: ' more in prizes to be able to withdraw your money.',
        totalTips18: 'Invite friends to complete tasks.',
        Silver: 'Silver',
        Gold: 'Gold',
        Diamond: 'Diamond',
        tab1: 'Report',
        tab2: 'My Reference',
        JustRemoved: 'just pulled',
        drawTitle1: 'Congratulations',
        drawTitle2: 'unfortunately',
        drawContent1: 'obtain',
        drawContent2: 'No reward received',
        cashOut: 'Cash Out',
        InviteFriends: 'Invite friends to get Money',
        nextFreeSpin: 'Next Free Spin:',
        targetAmount: 'Target Amount:',
        withdrawSuccessfully: 'Withdraw successfully',
        downTimeTips1: 'After',
        downTimeTips2: 'seconds,',
        downTimeTips3: 'the accumulated bonus and lottery times will be cleared',
        drawNumbers: 'Number of draws',
        winPopupTitle: 'Congratulations! You have won:',
        winPopupWithdrawTip: 'You can start a withdrawal when the accumulated amount reaches',
        winPopupButton: 'View tasks',
        winPopupHint: 'Complete missions to earn free spins',
        sharePopupTitle: 'Invite friends to help you withdraw',
        sharePopupRewardLabel: 'Reward amount received',
        sharePopupNeedText1: 'You still need',
        sharePopupNeedText2: 'to make a withdrawal',
        sharePopupTaskTip: 'Completing the following tasks can help you withdraw money faster:',
        sharePopupInviteTip1: 'Invite 1 valid game user and earn',
        sharePopupInviteTip2: 'free spin'
    },
    winRankList: {
        RankingList: 'Ranking List',
        Ranking: 'Ranking',
        Rules: 'Rules',
        MyRewards: 'My rewards',
        ActivityAward: 'Activity award:',
        Rank: 'Rank',
        Daily: 'Daily',
        Weekly: 'Weekly',
        Monthly: 'Monthly',
        WeeklyList: 'Weekly list',
        MonthlyList: 'Monthly list',
        TotalBets: 'Total Bets',
        Reward: 'Reward:',
        NoRank: 'No rank',
        MyBets: 'My Bets',
        RanksLeft: 'Ranks left',
        MyReward: 'My Reward',
        History: 'History',
        LastDay: 'Last Day',
        LastWeek: 'Last Week',
        LastMonth: 'Last Month',
        Rewards: 'Rewards',
        PhoneNo: 'Phone No.'
    },
    footer: {
        Promo: 'Promo',
        VIPClub: 'VIP Club',
        Promotions: 'Promotions',
        ReferAndEarn: 'Refer and Earn',
        Bonus: 'Bonus',
        AboutUs: 'About Us',
        About: 'About',
        DataProtectionPolicy: 'Data Protection Policy',
        BusinessContinuityPolicy: 'Business Continuity Policy',
        Help: 'Help',
        PrivacyPolicy: 'Privacy Policy',
        ServiceTerms: 'Service Terms',
        GamblingAddictionWarnings: 'Gambling Addiction Warnings',
        GamblingTreatmentCenters: 'Gambling Treatment Centers',
        ResponsibleGambling: 'Responsible Gambling',
        ContactUs: 'Contact  Us',
        JoinOurGroup: 'Join our group',
        ContactViaTelegram: 'Contact via Telegram',
        OnlineServer: 'Online Server',
        JoinourCommunity: 'Join our Community',
        tips1: '1.This product is for use by users over the age of 18 and is intended for entertainment purposes only.',
        tips2: '2.This game contains in-app purchases. ',
        tips3: '3.The fact that a player plays or wins in a social gambling game does not mean which he will win on real money bets and related games in the future.',
        socialMedia: 'social media',
        ApplicableTo: 'Applicable to'
    },
    joinChannel: {
        navTitle: 'Exciting Activities',
        mobileTitle: 'Join the community',
        mobileSubtitle: 'Plenty of rewards delivered on time',
        desktopTitle: 'Joining our official media channels brings many benefits.',
        desktopSubtitle: '{domainName} warmly invites you to join our Instagram, WhatsApp, and Telegram channels for smoother communication.',
        instagramBtn: 'Join Instagram',
        telegramBtn: 'Join Telegram',
        whatsappBtn: 'Join WhatsApp',
        infoIntro: 'We will announce the following activities and related information in our Telegram and WhatsApp channels:',
        info1: 'We will announce new platform activities on our Instagram, Telegram, and WhatsApp channels as soon as possible.',
        info2: 'We will regularly update platform rewards on our Instagram, Telegram, and WhatsApp channels.',
        info3: 'We will share {domainName} official bonus rewards every day.',
        info4: 'We will announce the platform winner list on our Instagram, Telegram, and WhatsApp channels as soon as possible.',
        info5: 'We will announce platform changes and maintenance on our Instagram, Telegram, and WhatsApp channels as soon as possible.',
        info6: 'We will announce referral reward system updates on our Instagram, Telegram, and WhatsApp channels as soon as possible.',
        info7: 'Any issue related to deposits and withdrawals will be announced on our Instagram, Telegram, and WhatsApp channels as soon as possible.',
        info8: 'Any game maintenance on the platform will be announced on our Instagram, Telegram, and WhatsApp channels as soon as possible.'
    },
    treasureChest: {
        treasureChest: 'treasure chest',
        title: 'Recommend friends to open the treasure chest',
        save: 'Click to Save',
        ReferralLink: 'Referral link',
        directSubordinates: 'Direct subordinates',
        ReferralCode: 'Referral Code',
        chestInfoTips1: 'What is an effective subordinate? (meets all requirements)',
        chestInfoTips2: 'Subordinates completed a total of ',
        chestInfoTips3: ' first refills',
        chestInfoTips4: 'Subordinate accumulator bets of ',
        chestInfoTips5: ' or more',
        People: 'People',
        People2: 'People',
        People3: 'People',
        commissionAccount: 'Commission Account',
        todayCommittee: 'The committee released today',
        historyCommittee: 'Published historical commissions',
        obtain: 'obtain',
        inviteTitle: 'Obtained by inviting valid subordinates',
        highestRebate: 'Highest rebate',
        commissionBalance: 'Commission balance',
        totalCommissionIncome: 'Total commission income',
        EstimatedCommissionToday: 'Estimated commission today',
        YesterdayCommittee: 'Yesterday committee',
        register: 'Register',
        firstChargeMark: 'First charge mark',
        firstFee: 'First fee',
        chargeAmount: 'Charge amount',
        totalHistoricalData: 'Total historical data',
        firstLevelSubordinateData: 'First level subordinate data',
        secondarySubordinateData: 'Secondary subordinate data',
        thirdLevelSubordinateData: 'Third level subordinate data',
        rewardRatio: 'Reward rate',
        collectRebates: 'Recharge rewards bonus',
        teamCollection: 'Recharge',
        firstLevelCommission: 'First level commission:',
        secondLevelCommission: 'Second level commission:',
        thirdLevelCommission: 'Third level commission:',
        firstLevelBetting: 'First level Betting:',
        secondLevelBetting: 'Second level Betting:',
        thirdLevelBetting: 'Third level Betting:',
        claim: 'claim',
        numberTreasureChestsClaimed: 'The number of treasure chests that can be claimed',
        noClaimedTips: 'There are currently no treasure chests available for collection'
    },
    Pending: {
        Pending: 'Pending',
        Hour: 'Hour',
        Type: 'Type',
        Bonus: 'Bonus',
        Limit: 'Limit',
        EndTime: 'End Time',
        All: 'All',
        DailyAttendance: 'Daily Attendance',
        TimedRedEnvelope: 'Timed red envelope',
        LuckyTurntable: 'Lucky turntable',
        ReliefMoney: 'Relief Money',
        RegisterRewards: 'Register Rewards',
        Other: 'Other'
    },
    depositTotal: {
        title: 'Accumulated recharge rewards',
        AccumulatedRecharge: 'Accumulated recharge',
        GetRewards: 'Get rewards',
        EventIntro: 'Event Instructions：'
    },
    depositRepeat: {
        full: 'full',
        RegisterFirstCharge: 'Register First Charge',
        DailyFirstCharge: 'Daily first charge',
        EachRecharge: 'Each recharge',
        give: 'give',
        thRecharge: 'th recharge',
        EveryRecharge: 'Every recharge',
        EventIntro: 'Event Instructions：'
    },
    scratchCards: {
        title: 'All Scratch Cards',
        prizeUpTo1: 'Prizes up to',
        prizeUpTo2: 'Prize up to',
        pixPayment: 'NO PIX',
        playNow: 'Play Now',
        price: 'Price',
        maxPrize: 'Maximum Prize',
        prizeTable: 'Prize Table',
        playFor: 'Play for',
        scratchTitle2: 'SCRATCH FIND WIN',
        winCondition1: 'Find 3 identical',
        winCondition2: 'win instantly',
        scratchAll: 'Scratch all at once',
        shaved: 'Shaved',
        youWon: 'You won',
        notThisTime: 'Not this time',
        encouragement: "But don't be discouraged, luck might be in the next scratch card",
        playAgain: 'Play again',
        yourBalance: 'Your balance',
        insufficientBalance: 'Insufficient balance',
        scrape: 'SCRAPE',
        here: 'HERE',
        playCard: 'Play Scratch Card',
        startPlay: 'Start playing',
        buyToPlay: 'Buy to play',
        buyTip1: 'Buy a scratch card to start playing',
        buyTip2: 'Click the button below to purchase',
        buyCard: 'Buy Scratch Card',
        prizeContent: 'CONTENT OF THIS SCRATCH CARD',
        congratulation: 'CONGRATULATIONS',
        addToAccount: 'The amount will be automatically added to your account.',
        revealAll: 'Reveal All',
        successTip: 'You are a winner, try again',
        failTip: 'You are not a winner, try again'
    },
    RedemptionCode: {
        tips1: 'Sign up for the channel to receive daily redemption coupons, and the money will be deposited directly into your account.',
        RedemptionCode: 'Redemption code',
        PleaseEnterTheRedemptionCode: 'Enter the redemption code.',
        PleaseEnterTheRedemptionCode2: 'Please go to the Telegram channel and WhatsApp channel to get.',
        exchange: 'Redeem a prize.',
        RedemptionRecord: 'Redemption Record'
    },
    red_envelope: {
        ClaimNow: 'Collect prizes',
        homepage: 'homepage',
        getMoney: 'Congratulations! Get ',
        remainder: 'remainder',
        GrabRedEnvelope: 'Grab a red envelope'
    },
    depositWithdraw: {
        MyAssets: 'My assets',
        TotalBalance: 'Total balance',
        WithdrawableAmount: 'Withdrawable amount',
        Recharge: 'Recharge',
        Retirar: 'Withdraw',
        records: 'records',
        RechargeAmount: 'Recharge amount',
        ExplanationBonusEvent: 'Explanation of the bonus event',
        MinimumDeposit: 'Minimum deposit ',
        RechargeBonusTips: 'Recharge according to the recommended value to receive the corresponding bonus. The bonus amount will be accumulated together with the recharge amount.',
        RechargeMethods: 'Recharge methods',
        DepositeAhora: 'Deposite ahora',

        MinimumWithdrawal: 'Minimum withdrawal ',
        ConfirmWithdrawal: 'Confirm withdrawal',

        RechargeRecords: 'Recharge records',
        WithdrawalRecords: 'Withdrawal records',
        rechargeTaskTip1: 'Only by recharging',
        rechargeTaskTip2: 'can you complete the task'
    },
    playGameByDeposit: {
        title: 'Recharge to unlock games',
        desc: 'Your exclusive game rewards are waiting. Activate them immediately after recharging.',
        activateNow: 'Activate now',
        reject: 'Cruel Rejection'
    },
    notification: {
        navTitle: 'Message Center',
        tabService: 'Service',
        tabInfo: 'Information',
        tabNotice: 'Notifications',
        tabAnnouncement: 'Announcements',
        serviceTitle: '24/7 Online Support',
        serviceDesc: 'Customer service is available to help solve problems and answer your questions.',
        serviceButton: '24/7 Support',
        onlineChatTitle: 'Online customer service',
        onlineChatDesc: 'If you need help, please contact customer service',
        service24Hours: '24-hour customer service',
        contactNow: 'Contact us now',
        officialGroupDesc: 'Join the official game community to get the latest game updates.',
        whatsappChannel: 'Official WhatsApp channel',
        telegramChannel: 'Official Telegram channel',
        instagramChannel: 'Official Instagram channel',
        joinNow: 'Join now',
        ad1: '<p>First deposit bonus up to <span style="color: rgb(230, 0, 0);">20%</span>! Minimum deposit is $20!</p>',
        ad2: '<p>Register and download the app to win great prizes!</p>',
        ad3: '<p>Many privileges when leveling up to <span style="color: rgb(230, 0, 0);">VIP! </span>Do not forget to use them!</p>',
        ad4: '<p>Daily check-in rewards - the more you recharge, the more rewards you will earn!</p>',
        ad5: '<p data-v-f8490b69="" class="ellipsis-1"><p>The more you recharge, the more bonuses you get! On your second deposit, receive up to a<span style="color: rgb(230, 0, 0);"> 10% </span>bonus. Enjoy!</p></p>',
        ad6: '<p>Invite your friends to play and win millions! Earn <span style="color: rgb(230, 0, 0);">$35</span> for every friend you invite.</p>',
        ad7: '<p>A good mindset is the most crucial weapon for your success.</p>',
        defaultInfoTitle: 'Your registration has been completed successfully',
        defaultInfoContent: '<p data-v-7e100e6c=""><p>🎉 <strong>Registration successful!</strong></p><p>Welcome to <strong>XO GROUP 🎰</strong></p><p>Your account has been created successfully - get ready to enjoy the best games and win big prizes! 💎</p><p>👉 <strong>Make your first deposit and receive up to a 20% extra bonus.</strong> 🚀</p></p>'
    },
    sports: {
        title: 'Sports',
        home: 'Home'
    },
    weeklySalary: {
        back: 'Back',
        heroTitle: 'VIP users, claim your upgrade rewards and weekly salary.',
        heroDesc: 'Recharge to unlock generous rewards and receive your weekly bonus.',
        currentLevel: 'Current level:',
        sectionTitle: 'Upgrade rewards',
        rulesHeading: 'VIP Weekly Bonus',
        rulesTitle: 'Event rules:',
        rule1: 'Each week, you will receive an exclusive cash reward based on your current VIP level.',
        rule2: 'The higher your VIP level, the larger your weekly bonus will be.',
        rule3: 'The bonus can be claimed every Wednesday after 05:00 a.m. directly to your account.',
        rule4: 'This event is limited to normal account-owner operations only. Rental accounts, bots, multiple accounts, wash trading, and arbitrage are strictly prohibited.',
        recordButton: 'Collection Record',
        recordSubtitle: 'History of weekly bonuses received',
        claim: 'Claim',
        claimed: 'Claimed',
        claimSuccess: 'Reward claimed successfully',
        stampFinished: 'Finished',
        stampLocked: 'Locked',
        stampAvailable: 'Available',
        completed: 'Completed',
        sent: 'Sent',
        recordEntry: 'Weekly Salary',
        levelLabelCurrent: 'Current level',
        levelLabelUpgrade: 'First VIP jump',
        levelLabelWeekly: 'Weekly reward',
        levelLabelPremium: 'Premium bonus',
        levelLabelTop: 'Top salary',
        navTitle: 'VIP Salary',
        tableLevel: 'Level',
        tableUpgradeRewards: 'Level rewards',
        tableWeeklySalary: 'Weekly salaries',
        detailRule3: 'The bonus can be claimed every Monday after 01:00 a.m. directly to your account.',
        detailRule4: 'This event is limited to normal account-owner operations only. Rental accounts, bots, multiple accounts, mutual mining, arbitrage, use of API or protocols, vulnerability exploitation, or group control are strictly prohibited. Otherwise, the reward may be canceled or deducted, and the account may be frozen or permanently blocked.',
        detailRule5: 'To avoid misunderstandings in the interpretation of the text, the platform reserves the final right to interpret this event.',
        recordNavTitle: 'VIP Rewards',
        recordTabUpgrade: 'Level reward',
        recordTabWeekly: 'Weekly salary',
        recordTableVipLevel: 'VIP Level',
        recordTableUpgradeAmount: 'Upgrade rewards',
        recordTableWeeklyAmount: 'Salary',
        recordTableTime: 'Time',
        rescueRecordNavTitle: 'Loss Subsidy',
        rescueRecordTabDaily: 'Daily Relief Payment',
        rescueRecordTabWeekly: 'Weekly Relief Payment',
        rescueRecordTableVipLevel: 'VIP Level',
        rescueRecordTableFunds: 'Relief funds',
        rescueRecordTableTime: 'Time',
        upBonusTitle: 'Super Reward',
        upBonusDesc1: 'You can currently claim a regular reward of',
        upBonusDesc2: 'but by depositing',
        upBonusDesc3: 'you can claim a super bonus of',
        upBonusSuperDouble: 'Super Double',
        upBonusCommon: 'Common'
    },
    weeklyRescue: {
        navTitle: 'Loss Subsidy',
        dailyTab: 'Daily Relief Payment',
        weeklyTab: 'Weekly Relief Payment',
        dailyTitle: "Today's subsidy",
        weeklyTitle: "This week's subsidy",
        dailyDesc: 'It can be collected at {time} on the following day.',
        weeklyDesc: 'It can be collected on Monday at {time} in the morning.',
        level: 'Level',
        lossAmount: 'Loss amount',
        subsidy: 'Subsidy',
        recordButton: 'Collection Record',
        yesterdaySubsidy: 'Yesterday subsidy',
        lastWeekSubsidy: 'Last week subsidy',
        redeemSuccessTitle: 'Redeemed successfully',
        redeemSuccessMessage: 'Get {currencyType} {amount}',
        confirmButton: 'Confirm'
    },
    socialMedia: {
        socialMedia: 'social media'
    },
    claimRedEnvelope: {
        Envelope: 'Envelope',
        totalTips1: 'Deposit ',
        totalTips2: ' today to participate. You deposited ',
        totalTips3: 'Bet ',
        totalTips4: ' today to participate. You placed a ',
        totalTips5: ' bet.',
        totalTips6: 'The maximum limit for this round of red envelopes is ',
        totalTips7: ' times',
        totalTips8: 'This is the ',
        totalTips9: 'th red envelope',
        Claimed: 'Claimed',
        late: 'late',
        enter: 'Enter',
        getSuccTitle: 'Congratulations',
        getSuccContent: 'obtain',
        YouCanGet: 'Randomly obtained ',
        noticeLabel: 'Lista de sobres rojos:',
        eventOver: 'The event is over',
        eventStart: 'The activity is in progress',
        needTips1: 'Deposit {amount} today to claim this red envelope.',
        needTips2: 'Wager {amount} today to claim this red envelope.',
        needTips3: 'Requirements not met',
        needTips4: 'You do not meet the eligibility criteria to claim the reward',
        upTips1: 'You can now claim a small red envelope. Deposit {upAmount} to get a larger red envelope with extra rewards.',
        upTips3: 'Deposit {amount} to claim a small red envelope; deposit {upAmount} for a larger one with better rewards.',
        upTips6: 'Wager {amount} to claim a small red envelope; deposit {upAmount} to get a larger one with higher rewards.',
        upTips7: 'Get your upgrade bonus red envelope now:',
        UpgradeRedEnvelope: 'Upgrade Red Envelope',
        RegularRedEnvelope: 'Regular Red Envelope',
        DepositedBalance: 'Deposited to balance',
        redPacketTitle: "Congratulations! You've received the red envelope bonus."
    },
    BalanceUnavailable: {
        RechargeOrder: 'Collection Order',
        RechargeGift: 'Recharge Bonus',
        ManualAddition: 'Manual Top-up',
        RecommendFirstRecharge: 'Referral First Deposit Bonus',
        VIPUpLevel: 'VIP Level-up Bonus',
        VIPDailyCheckIn: 'VIP Daily Check-in',
        MemberLevelDayReward: 'Tier Daily Reward',
        MemberLevelWeeklyReward: 'Tier Weekly Reward',
        MemberLevelMonthlyReward: 'Tier Monthly Reward',
        UnlockedAmt: 'Unfrozen Amount',
        RedEnvelope: 'Red Envelope Claim',
        TimedRedPacket: 'Timed Red Envelope',
        LossSupport: 'Loss Compensation Fund',
        ActivityValReward: 'Activity Points Reward',
        OrderRebate: 'Wager Rebate',
        DailyCheckIn: 'Daily Check-in',
        registerRewardsEvent: 'Registration Reward Event',
        loginRewardsEvent: 'Login Reward Event',
        NewcomerBonusEvent: 'Newcomer Bonus Event',
        rankingListEvent: 'Leaderboard Event',
        waterReturnEvent: 'Instant Cashback Event',
        GameBettingEvent: 'Wagering Turnover Event',
        LuckyWheel: 'Lucky Wheel',
        interestsEvent: 'Interest Treasure Event',
        LotteriesWithdraw: 'Lottery Draw Withdrawal',
        TotalRechargeEvent: 'Cumulative Deposit Event',
        RechargeRebate: 'Deposit Commission',
        bonus: 'bonus',
        WithdrawalRequest: 'Withdrawal Request',
        bettors: 'bettors',
        restrictedPlatform: 'restricted platform'
    }
}
